import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ForumAnnouncementService {
  private readonly visibleSubject = new BehaviorSubject<boolean>(false);
  readonly visible$ = this.visibleSubject.asObservable();

  setVisible(visible: boolean): void {
    this.visibleSubject.next(visible);
  }

  hide(): void {
    this.visibleSubject.next(false);
  }
}
